import { render, staticRenderFns } from "./ProfileViewTemplate.vue?vue&type=template&id=548706c5&scoped=true&"
import script from "./ProfileViewTemplate.vue?vue&type=script&lang=js&"
export * from "./ProfileViewTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProfileViewTemplate.vue?vue&type=style&index=0&id=548706c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548706c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCard,VIcon,VSpacer,VToolbar,VToolbarTitle})
